exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3qyYZ_ffqe5APT{flex:0 0 auto;height:256px;width:342px}._3qyYZ_ffqe5APT ._2p3PhyOTjTSgOK{height:50px;margin-left:190px;margin-top:20px;opacity:0;width:50px}._3qyYZ_ffqe5APT ._5VZiUurmmp2g4l{height:50px;margin-left:190px;transform:translateY(-70px);opacity:1;transition:all .5s cubic-bezier(.175,.885,.32,1.275) .2s;width:50px}", ""]);

// exports
exports.locals = {
	"illustrationWrapper": "_3qyYZ_ffqe5APT",
	"newMemberHidden": "_2p3PhyOTjTSgOK",
	"newMemberVisible": "_5VZiUurmmp2g4l"
};